import React, { useRef, useState, useEffect } from "react";
import "./Modal.css";
import { getUserData } from "../../utils/FunctionHelpers";
import { Autocomplete, TextField } from '@mui/material';
import { FiSend } from "react-icons/fi";
import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  Modal,
} from "@mui/material";
import { Select, OutlinedInput, MenuItem } from "@mui/material";
import TagsInput from "../../utils/TagsInput";
import { BiMailSend } from "react-icons/bi";
import { withSnackbar } from "../../utils/SnackbarHOC";
import EditorCustom from "../EditorCustorm/EditorCustom";
import { removeLineBreak } from "../../utils/EditorUtil";
import { Fade, Typography } from "@mui/material";
import AttachFile from '@mui/icons-material/AttachFile';
import Close from '@mui/icons-material/Close';
import { getAllUsersForTasks } from "../../services/UserService";
import { listEmailTypes } from "../../services/EmailTypeService";
import { v4 } from "uuid";


const EmailModal = ({ showButton = true, emailTarget, openModal, setOpenModal, handleOpenModal, messageType, ...props }) => {
  const [errors, setErrors] = useState({});
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);
  const [scheduledDate, setScheduledDate] = useState(null);
  const loading = open && options.length === 0;
  const [de, setDe] = useState(getUserData().email);
  const [cc, setCc] = useState([]);
  const [cci, setCci] = useState([]);
  const [objet, setObjet] = useState("");
  const [Messages, setMessages] = useState(messageType);
  const [user, setUser] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const isActive = useRef();
  const [dataUpload, setDataUpload] = useState([]);
  const uploadRef = useRef(null);
  const messageHtml = `
  <div>
    <p>Bonjour ${props.prenom?.charAt(0).toUpperCase() + props.prenom?.slice(1)},</p>
    <br></br><p>Bien cordialement</p>
  </div>
  `;

  const [message, setMessage] = useState(messageHtml);

  const handleCloseModal = () => {
    setOpenModal(false);
    setMessage("<br></br><p>Bien cordialement</p>")
    setErrors("")
  };

  const handleSelectedCC = (ccs) => {
    setCc(ccs);
  };

  const handleSelectedCCI = (ccis) => {
    setCci(ccis);
  };

  const clearFieds = () => {
    setMessage("");
    setObjet(null);
    setCc([]);
    setCci([]);
    setDataUpload([])
  };

  const validate = () => {
    let temp = {};
    temp.de = de ? "" : "Le champ 'emetteur' est obligatoire.";
    temp.objet = objet ? "" : "Le champ 'objet' est obligatoire.";
    temp.message = !(message?.replace(/<\/?[^>]+(>|$)/g, "") === "") ? "" : "Le champ 'Message' est obligatoire.";;
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };
  const [messageTypeValue, setMessageTypeValue] = useState({msgName: "", objet: ""});

  const messageTypeChanged = (values) => {
    setMessageTypeValue(values);
    const replacements = [
      ["PRENOM CDT", props.prenom],
      ["Mr/Mme NOM DU CLT", props.prenom],
      ["Prénom CDT", props.prenom],
      ["Prénom", props.prenom],
      ["Madame", props.prenom],
      ["[Prenom_CDT]", props.prenom],
    ];

    const msgTxt = values?.message || "-";
    const updatedMsgTxt = replacements.reduce((txt, [search, replacement]) => {
      const formattedReplacement = replacement?.charAt(0).toUpperCase() + replacement?.slice(1);
      return txt.replace(search, formattedReplacement);
    }, msgTxt);
    setMessages(values?.msgName || "-");
    setObjet(values?.objet || "-");
    setMessage(updatedMsgTxt);
  };

  useEffect(()=>{
    if(messageType){
      const value = options?.find(type => type.msgName == messageType);
      messageTypeChanged(value);
    }
  }, [openModal])

  useEffect(()=>{
    messageTypeChanged(messageTypeValue);
  }, [messageTypeValue])

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setLoadingUsers(true);
        const { data } = await getAllUsersForTasks();
        if (!active) return;
        setUser(data);
        setLoadingUsers(false);
      } catch (err) {
        props.snackbarShowMessage(
            "Erreur de chargement des utilisateurs.",
            "error",
            4000
        );
      } finally {
        setLoadingUsers(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [openModal]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props?.category === 'candidat') {
          const { data } = await listEmailTypes(`?type=email&subject=candidat`);
          setOptions(data);
        } else if (props?.category === 'contact') {
          const [typeMessageProspect, typeMessageClient] = await Promise.all([
            listEmailTypes(`?type=email&subject=prospect`),
            listEmailTypes(`?type=email&subject=client`),
          ]);
          setOptions([...typeMessageClient.data, ...typeMessageProspect.data])
        }
      } catch (err) {
        props.snackbarShowMessage(
            "Erreur de chargement des email types.",
            "error",
            4000
        );
      }
    };
    fetchData();
  }, [openModal]);


  const appendArrayToFormData = (formData, key, array) => {
    if (array.length > 0) {
      array.forEach((name, index) => {
        formData.append(`${key}[${index}]`, name);
      });
    } else {
      formData.append(key, []);
    }
  };

  const handleSend = async () => {
    if (!validate()) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append('de', de);
      appendArrayToFormData(formData, 'cc', cc);
      appendArrayToFormData(formData, 'cci', cci);
      formData.append('msg', removeLineBreak(message));
      formData.append('objet', objet);
      formData.append(props.category, props.id);
      formData.append(
          'commentaire',
          `<div style={{display:"flex"}}> MAIL : \n${objet}\n${removeLineBreak(message)}</div>`
      );
      formData.append('auteur', getUserData().uuid);
      dataUpload.map((file, index) => formData.append(`pj[${index}]`, file))
      if (isScheduled && scheduledDate) {
        formData.append("scheduleDate", scheduledDate.toISOString());
      }
      if (isActive) {
        props.snackbarShowMessage(
            "Envoie d'email en cours...",
            "warning",
            null
        );
        const { data } = await props.serviceEmail(formData);
        props.snackbarShowMessage(data, "success", 4000);
        props.setLoadData(!props.loadData);
        clearFieds();
      }
    } catch (error) {
      props.snackbarShowMessage(
          "Erreur de l'envoie de mail.",
          "error",
          4000
      );
    }

    handleCloseModal();
  };

  const handleSender = async (id) => {
    setDe(id);
  };

  const editorCustomProps = {
    value: message,
    setValue: setMessage,
    enableOnBlur: false
  };

  const body = (
        <div className="modalContainer crm-modal--composer crm-email-composer">
          <Box className="crm-email-composer__header">
            <Box className="crm-email-composer__titleWrap">
              <Box className="crm-email-composer__icon">
                <BiMailSend />
              </Box>
              <Box>
                <Typography className="crm-email-composer__eyebrow">
                  Communication
                </Typography>
                <Typography className="crm-email-composer__title">
                  Emailing
                </Typography>
              </Box>
            </Box>
            <IconButton
              aria-label="Fermer"
              onClick={handleCloseModal}
              disabled={loading}
              size="small"
              className="crm-email-composer__close"
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
          <div className="crm-modal__scrollArea">
            <div>
              <FormControl
                  {...(errors.de && {
                    error: true,
                    label: errors.de,
                  })}
                  fullWidth
              >
                <label className="input-label" htmlFor="messages">
                  De <span className="required-input">*</span>
                </label>
                <Select
                    value={user.length !== 0 && !loadingUsers ? de : ""}
                    name="users"
                    style={{ width: "100%" }}
                    onChange={(e) => {
                      handleSender(e.target.value);
                    }}
                    input={
                      <OutlinedInput
                          name="de"
                          {...(errors.de && {
                            labelWidth: 280,
                          })}
                          notched
                      ></OutlinedInput>
                    }
                >
                  {loadingUsers ? (
                      <CircularProgress />
                  ) : (
                      user.map((user) => (
                          <MenuItem
                              selected={"EmailUser"}
                              onChange={(e) => setDe(e.target.value)}
                              value={user.email}
                              key={user.uuid}
                          >
                            {`${user.email}`}
                          </MenuItem>
                      ))
                  )}
                </Select>
              </FormControl>
            </div>

            <div>
              <label className="input-label" htmlFor="cci">
                CC
              </label>
              <TagsInput
                  selectedTags={handleSelectedCC}
                  fullWidth
                  id="cc"
                  name="cc"
                  validation={/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/}
                  placeholder="Ajouter des CC"
              />
            </div>
            <div>
              <label className="input-label" htmlFor="cci">
                CCI
              </label>
              <TagsInput
                  selectedTags={handleSelectedCCI}
                  fullWidth
                  variant="outlined"
                  id="cci"
                  name="cci"
                  placeholder="Ajouter des CCI"
              />
            </div>
            <div>
              <label className="input-label" htmlFor="messages">
                Message Type
              </label>
              <Autocomplete
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  getOptionSelected={(option, value) =>
                      option.msgName === value.msgName
                  }
                  getOptionLabel={(option) => option.msgName}
                  onChange={(event, values) => messageTypeChanged(values)}
                  options={options}
                  loading={loading}
                  value={messageTypeValue}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          value={Messages ?? ""}
                          placeholder={Messages ?? ""}
                          {...(errors.Messages && {
                            error: true,
                            label: errors.Messages,
                          })} slotProps={{ ...params.slotProps, input: { ...params.slotProps?.input, ...({
                            ...params.slotProps.input,
                            endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                      <CircularProgress color="inherit" size={20} />
                                  ) : null}
                                  {params.slotProps.input?.endAdornment}
                                </React.Fragment>
                            ),
                          }) } }}
                      />
                  )}
              />
            </div>
            <div>
              <label className="input-label" htmlFor="objet">
                Objet<span className="required-input"> *</span>
              </label>
              <TextField
                  id="objet"
                  value={objet}
                  margin="normal"
                  variant="outlined"
                  autoComplete="off"
                  onChange={(e) => setObjet(e.target.value)}
                  fullWidth
                  {...(errors.objet && {
                    error: true,
                    label: errors.objet,
                  })}
              />
            </div>
            <div>
              <label className="input-label" htmlFor="message">
                Message <span className="required-input"> *</span>
              </label>
              {errors.message && (
                  <Typography variant="body2" color="error">
                    {errors.message}
                  </Typography>
              )}
              <EditorCustom {...editorCustomProps} />
            </div>
            {dataUpload.length > 0 && (
                <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                      height: "100%",
                      overflow: "hidden",
                      maxWidth: "800px",
                      flexWrap: "wrap",
                      padding: "10px 0 0 0 "

                    }}
                    className="input-label"

                >
                  <span>PJ:</span>
                  {dataUpload.map((file, indexToRemove) =>
                      <Chip
                          key={v4()}
                          label={file.name}
                          variant="default"
                          onDelete={() => setDataUpload(prevData => prevData.filter((_, index) => index !== indexToRemove))}
                          size="small"
                      />
                  )}

                </Box>
            )}
          </div>
          <Box sx={{
            display: "flex",
            gap: "10px",
            justifyContent: "end",
            width: "100%",
            marginLeft: "-20px",
            marginTop: "10px"
          }}
               className="modal-footer crm-email-composer__footer">
            <Button
                variant="contained"
                sx={{ background: 'linear-gradient(135deg, #0556a4, #03407b)', color: '#fff', borderRadius: '10px', textTransform: 'none', fontWeight: 600, '&:hover': { background: 'linear-gradient(135deg, #03407b, #022d68)' } }}
                onClick={() => setIsScheduled(!isScheduled)}
            >
              {isScheduled ? "Annuler Programmation" : "Envoi Programmer"}
            </Button>

            {isScheduled && (
                <TextField
                    type="datetime-local"
                    onChange={(e) => {
                      const localDate = new Date(e.target.value);
                      const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
                      setScheduledDate(utcDate);
                    }}
                    variant="outlined"
                    margin="normal"
                    required
                />
            )}
            {!dataUpload.length > 0 && (
                <Box sx={{ display: "flex" }}>
                  <input
                      type="file"
                      onChange={(e) => setDataUpload(Array.from(e.target.files))}
                      style={{ display: "none" }}
                      ref={uploadRef}
                      multiple
                  />
                  <IconButton
                      onClick={() => uploadRef.current.click()}
                      data-toggle="tooltip"
                      title="Ajouter PJ"
                  >
                    <AttachFile style={{ fontSize: "20px" }} color="primary" />
                  </IconButton>
                </Box>
            )}
            <Button
                sx={{ background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: '10px', textTransform: 'none', fontWeight: 600, '&:hover': { background: '#e2e8f0' } }}
                onClick={handleCloseModal}
                disabled={loading}
            >
              Annuler
            </Button>
            <Button
                startIcon={<FiSend />}
                sx={{ background: 'linear-gradient(135deg, #0556a4, #03407b)', color: '#fff', borderRadius: '10px', textTransform: 'none', fontWeight: 600, boxShadow: '0 2px 8px rgba(3,64,123,0.28)', '&:hover': { background: 'linear-gradient(135deg, #03407b, #022d68)' } }}
                disabled={loading}
                onClick={handleSend}
            >
              Envoyer
            </Button>
          </Box>
        </div>
  );

  return (
      <>
        {showButton && 
          <Button
              startIcon={<BiMailSend color="117aa7" />}
              className={props?.className}
              data-toggle="tooltip"
              title="EMAIL"
              onClick={handleOpenModal}
          ></Button>
        }
        <Modal
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            open={openModal}
            onClose={handleCloseModal}
        >
          <Fade in={openModal}>{body}</Fade>
        </Modal>
      </>
  );
};
export default withSnackbar(EmailModal);
